import script from "./batch-ambiguous-background.vue?vue&type=script&setup=true&lang=js"
export * from "./batch-ambiguous-background.vue?vue&type=script&setup=true&lang=js"

import "./batch-ambiguous-background.vue?vue&type=style&index=0&id=2af47154&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af47154"]])

export default __exports__